import { sendDirectNotices, type DirectNoticePayload } from "./directNotices";
import type { ParentChild } from "../types/parentFamily";

export function getChildGuardianUserIds(
  child: ParentChild,
  fallbackUserId: string
): string[] {
  const ids = Array.from(
    new Set(
      (child.guardians ?? [])
        .map((g) => g.userId?.trim())
        .filter((id): id is string => Boolean(id))
    )
  );
  if (ids.length > 0) return ids;
  const fallback = fallbackUserId?.trim();
  return fallback ? [fallback] : [];
}

export function feeSendButtonLabel(recipientCount: number): string {
  return recipientCount <= 1 ? "Send to parent" : "Send to parents";
}

export async function publishDirectNoticesToUsers(
  recipientUserIds: string[],
  payload: DirectNoticePayload,
  token: string
): Promise<void> {
  if (recipientUserIds.length === 0) {
    throw new Error("No linked parents to send this statement to.");
  }
  await sendDirectNotices(recipientUserIds, payload, token);
}
